module.exports = __webpack_public_path__ + "img/logo.svg?v=6a236f7";